import { getProductBasedOfferId } from 'pricing-pages-lib/utils/offerUtils';
import { getRequiredOnboardingSkuIdsWithRecommendedFallback } from 'pricing-pages-lib/utils/requiredOnboardingUtils';
import { getProductVersion } from './productsUtils';

/**
 * Takes in a list of skuIds and returns any productBasedOfferIds
 * for that sku, and any onboarding that also has productBasedOfferIds
 */
export const getProductBasedOfferIdsWithMandatorySku = (state, {
  skuIds
}) => {
  const offerIds = [];
  skuIds.filter(skuId => getProductVersion(state, {
    skuId
  }).skuId === skuId).forEach(skuId => {
    const onboardingSkuIds = getRequiredOnboardingSkuIdsWithRecommendedFallback(state, {
      skuId,
      allSkuIds: skuIds,
      withProductBasedOffers: true
    });
    const productBasedOfferId = getProductBasedOfferId(state, {
      skuId
    });
    if (productBasedOfferId) {
      offerIds.push(productBasedOfferId);
    }
    if (onboardingSkuIds && onboardingSkuIds.length) {
      onboardingSkuIds.forEach(onboardingSkuId => {
        const onboardingOfferId = getProductBasedOfferId(state, {
          skuId: onboardingSkuId
        });
        if (onboardingOfferId) offerIds.push(onboardingOfferId);
      });
    }
  });
  return offerIds;
};